<template>
    <AppCard class="flex flex-col items-left" :class="{ '!border-none !border-transparent !filter-none !drop-shadow-none !shadow-transparent': !showBorder }">
        <header>
            <slot name="header"></slot>
        </header>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <div class="relative w-full">
                <div class="absolute left-0 top-2 w-16" v-if="product.badges && product.badges.length">
                    <img class="lazy" :data-src="product.badges[0].path" :alt="product.badges[0].name"/>
                </div>

                <Link :href="reviewsLink">
                    <img class="max-h-52 max-w-fit mx-auto mb-2 lazy" :data-src="tyreImage"/>
                </Link>
            </div>
            <div class="justify-center">
                <Link class="w-full" :href="route('brands.show', product.brand)" v-if="product.brand">
                    <!--            <img class="max-h-8 max-w-fit mb-2 lazy object-cover" :data-src="product.brand.image"/>-->
                    <div class="w-full h-8 mb-2 bg-cover bg-no-repeat lazy bg-center max-w-[150px] mx-auto"
                         :style="{'background-image': 'url(' + product.brand.image + ')'}"></div>
                </Link>

                <p class="text-dark mb-2 px-4 text-center min-h-content flex-grow flex items-center">
                    <template v-if="product.brand">{{ product.brand.name }}</template>
                    {{ product.name }}
                </p>

                <ReviewStarRating class="mt-2 w-full px-16 md:px-8"
                                  :modelValue="product.reviews_avg_rating"
                                  size="1x"
                                  spacing="space-x-2"></ReviewStarRating>

                <AppButton class="!flex !md:inline-flex mt-2 text-center md:text-left whitespace-nowrap" :href="reviewsLink">
                    Read Reviews
                </AppButton>

                <p class="my-2 text-sm text-center">{{ product.reviews_count ?? 0 }} reviews</p>
            </div>
        </div>
    </AppCard>
</template>

<script>
import {Link} from "@inertiajs/inertia-vue3";
import ReviewStarRating from "@/Components/Reviews/ReviewStarRating";
import AppButton from "@/Components/AppButton";
import AppCard from "@/Components/AppCard";
import LazyLoad from "vanilla-lazyload";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
    components: {AppCard, AppButton, ReviewStarRating, LazyLoad, FontAwesomeIcon, Link},
    props: {
        product: Object,
        showBorder: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        reviewsLink() {
            return this.route("products.show", this.product);
        },
        tyreImage() {
            return this.product.image ?? "/images/misc/default_tyre.jpeg";
        }
    },
    mounted()
    {
        var lazyLoadInstance = new LazyLoad({});
    }
};
</script>

<style scoped>

</style>
